import * as React from 'react';
import { styled } from '@mui/system';
import { Divider } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import NoteEditSelectAndPostButton from '../NoteEditSelectAndPostButton';
import NoteEditTitle from '../NoteEditTitle';
import NoteEditContent from '../NoteEditContent';
import NoteEditAddOrRemoveCafe from '../NoteEditAddOrRemoveCafe';

const EditPageRightSectionContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '415px',
  paddingLeft: '33px',
  [theme.breakpoints.down('md')]: {
    width: '350px',
    padding: '0',
    margin: '0 auto',
  },
}));

const NoteEditPageDividerBetweenTitleAndContent = styled(Divider)(({ theme }) => ({
  width: '383px',
  borderBottom: '2px solid rgb(166,146,123)',
  [theme.breakpoints.down('md')]: {
    width: '350px',
  },
}));

const NoteEditSection = ({ formik }) => {
  const mobileMatch = useMediaQuery((theme) => theme.breakpoints.down('md'));

  return (
    <EditPageRightSectionContainer>
      {mobileMatch ? (
        <>
          <NoteEditTitle formik={formik} />
          {/* <NoteEditPageDividerBetweenTitleAndContent /> */}
          <NoteEditContent formik={formik} />
          <NoteEditAddOrRemoveCafe formik={formik} />
          <NoteEditSelectAndPostButton formik={formik} />
        </>
      ) : (
        <>
          <NoteEditSelectAndPostButton formik={formik} />
          <NoteEditTitle formik={formik} />
          {/* <NoteEditPageDividerBetweenTitleAndContent /> */}
          <NoteEditContent formik={formik} />
          <NoteEditAddOrRemoveCafe formik={formik} />
        </>
      )}
    </EditPageRightSectionContainer>
  );
};

export default NoteEditSection;
